import { useMsal } from "@azure/msal-react";
import { Button } from "baseui/button";
import { FormattedMessage } from "react-intl";

const scopes = {
  scopes: ["User.Read"],
};

function handleLogin(instance: any) {
  instance.loginRedirect(scopes).catch((e: any) => {
    console.error(e);
  });
}

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
const SignInButton = () => {
  const { instance } = useMsal();

  return (
    <Button
      overrides={{
        BaseButton: { style: { width: "200px" } },
      }}
      shape="pill"
      onClick={() => {
        handleLogin(instance);
      }}>
      <FormattedMessage id="SignInButton.text" defaultMessage="Login" />
    </Button>
  );
};

export default SignInButton;
